import * as React from 'react';
import { Button, Col, Row } from 'reactstrap';
import { Line } from 'src/components/shared/Line';
import { Svg } from 'src/components/shared/Svg';
import {
  IGlobalContextProps,
  withGlobalContext,
} from 'src/context/global.context';
import { IStep } from 'src/model';
import { startStep, validateStep } from 'src/services';

const WorkspaceStepItemConfig = {
  initial: 'dark',
  started: 'secondary',
  validated: 'primary',
};

interface IWorkspaceStepItemProps {
  step: IStep;
  handleStepListChange: (step: IStep) => void;
}

const WorkspaceStepItem: React.SFC<
  IWorkspaceStepItemProps & IGlobalContextProps
> = ({ context, handleStepListChange, step }) => {
  const { user } = context;
  const isClient = user && user.type === 'client';

  const isLate = (date: Date) => {
    const duration = Math.floor(
      ((step.meta.status !== 'validated'
        ? new Date().getTime()
        : new Date(step.meta.lastModified).getTime()) -
        new Date(date).getTime()) /
        (1000 * 60 * 60 * 24)
    );
    return duration > 0 ? duration : 0;
  };

  const handleClick = async (status: string) => {
    const newStep =
      status === 'initial'
        ? await startStep(step._id)
        : await validateStep(step._id);
    if (newStep) {
      handleStepListChange(newStep);
    }
  };

  return (
    <Row>
      <Col
        className='d-flex flex-column align-items-center position-relative'
        xs='2'
      >
        <span
          className='step-number text-center text-white mt-1'
          style={{ zIndex: 10 }}
        >
          {step.stepNumber}
        </span>
        <Svg
          className='position-absolute'
          width={48}
          height={48}
          fill={WorkspaceStepItemConfig[step.meta.status]}
          opacity={step.meta.status === 'initial' ? 0.25 : 1}
          src='step-bulle'
        />
        <Line
          className='mt-2'
          width={2}
          height={90}
          fill={WorkspaceStepItemConfig[step.meta.status]}
          plain={step.meta.status === 'validated'}
        />
      </Col>
      <Col xs='10'>
        <span className='text-primary'>{step.title}</span>
        <div className='mt-1 mb-2'>
          {step.startingDate && (
            <>
              <Svg
                width={18}
                fill='secondary'
                src='start-up'
                style={{ transform: 'rotate(45deg)' }}
              />
              <span
                className='text-secondary ml-1 mr-2'
                style={{ fontSize: '10px' }}
              >
                {new Date(step.startingDate).toLocaleDateString()}
              </span>
            </>
          )}
          {step.estimatedEndDate && (
            <>
              <Svg width={18} fill='primary' src='racing-flag' />
              <span
                className='text-primary ml-1 mr-3'
                style={{ fontSize: '10px' }}
              >
                {new Date(step.estimatedEndDate).toLocaleDateString()}
              </span>
            </>
          )}
          {isLate(step.estimatedEndDate) ? (
            <>
              <Svg width={18} height={18} fill='danger' src='delay' />
              <span
                className='text-danger ml-1 mr-3'
                style={{ fontSize: '10px' }}
              >
                {`Retard : ${isLate(step.estimatedEndDate)} jour${
                  isLate(step.estimatedEndDate) > 1 ? 's' : ''
                }`}
              </span>
            </>
          ) : step.meta.status === 'validated' ? (
            <>
              <Svg width={18} height={18} fill='success' src='on-time' />
              <span
                className='text-success ml-1 mr-3'
                style={{ fontSize: '10px' }}
              >
                Livré
              </span>
            </>
          ) : null}
          {step.meta.status === 'initial' ? (
            <Button
              className='text-uppercase text-white bg-primary border-0'
              size='sm'
              style={{ fontSize: '10px' }}
              onClick={() => handleClick('initial')}
            >
              Démarrer l'étape
            </Button>
          ) : isClient && step.meta.status === 'started' ? (
            <Button
              className='text-uppercase text-white bg-success border-0'
              size='sm'
              style={{ fontSize: '10px' }}
              onClick={() => handleClick('started')}
            >
              Étape finie
            </Button>
          ) : null}
        </div>
        <p className='mb-4' style={{ fontSize: '12px' }}>
          {step.description}
        </p>
      </Col>
    </Row>
  );
};

export const WorkspaceStepItemWithGlobalContext = withGlobalContext(
  WorkspaceStepItem
);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectWorkspace/WorkspaceStepList/WorkspaceStepItem.tsx